import React, { useEffect, useState } from "react";
import { getMatches } from "../api/matches";
function formatFechaBonita(fechaISO) {
  const [year, month, day] = fechaISO.split("-");
  const meses = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  return `${parseInt(day)} ${meses[parseInt(month) - 1]} ${year}`;
}

export default function MainScreen({ token, onLogout }) {
  const [matches, setMatches] = useState([]);

  useEffect(() => {
    getMatches(token).then(setMatches);
  }, [token]);

  // Filtra los partidos por nº de coincidencias
  const encontrados = matches.filter((m) => m.count >= 4);
  // Filtra partidos posibles: 2 o 3 personas
  const posibles = matches.filter((m) => m.count === 2 || m.count === 3);

  // Ordena: primero los de 3, luego los de 2
  const posiblesOrdenados = [...posibles].sort((a, b) => b.count - a.count);

  return (
    <div className="p-4 max-w-xl mx-auto">
      {/* Partidos ENCONTRADOS */}
      <div className="mb-6">
        <h3 className="text-lg font-semibold mb-2">Partidos encontrados</h3>
        {encontrados.length === 0 ? (
          <p className="text-gray-500">Ningún partido con 4 o más personas todavía.</p>
        ) : (
          <ul className="space-y-2">
            {encontrados.map((match, i) => (
              <li key={i} className="bg-green-100 border border-green-300 shadow rounded-xl p-4">
                <div>
                  <b>{formatFechaBonita(match.date)}</b> {match.hour.slice(0, 5)}
                </div>
                <div className="text-gray-700">{match.users.join(", ")}</div>
                <div className="text-green-800 text-sm">{match.count} personas disponibles</div>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Partidos POSIBLES */}
      <div>
        <h3 className="text-lg font-semibold mb-2">Partidos posibles</h3>
        {posiblesOrdenados.length === 0 ? (
          <p className="text-gray-500">No hay coincidencias de 2 o 3 personas todavía.</p>
        ) : (
          <ul className="space-y-2">
            {posiblesOrdenados.map((match, i) => (
              <li key={i} className="bg-white shadow rounded-xl p-4 relative">
                <div>
                  <b>{formatFechaBonita(match.date)}</b> {match.hour.slice(0, 5)}
                </div>
                <div className="text-gray-700">{match.users.join(", ")}</div>
                <div className="text-gray-500 text-sm">{match.count} personas disponibles</div>
                {match.count === 3 && <div className="absolute top-2 right-4 text-xs px-2 py-1 rounded bg-red-100 text-red-700 font-bold shadow animate-pulse">¡Falta uno!</div>}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

